import { Header } from 'semantic-ui-react';
import WorksheetForm from '../common/components/WorksheetForm';
import { WorksheetField } from '../common/components/Field';
import { RecOwnershipRadioOptions, Unit, UnitDecimals } from '~/constants';
import { InputType } from '~/schema';
import { useDerivedRECFields } from '../../derived';
import { useDerivedProjectSetupFields } from '../../derived';
import ItcAddersForm from '../../components/Worksheet/Budget/UpfrontIncentives/ItcAddersForm';
import PricingEstimateFields from './PricingEstimateFields';
import PricingEstimatePropertyTax from './PricingEstimatePropertyTax';
import PricingEstimateRevenueStream from './PricingEstimateRevenueStream';
import PricingEstimateOperatingExpenses from './PricingEstimateOperatingExpenses';
import StateSpecificRECForm from '../../components/Worksheet/Revenue/RenewableEnergyCredits/StateSpecificRECForm';
import { useProjectContext } from '~/hooks';
import './styles.scss';

export default function PricingEstimateWorksheet() {
  const { project } = useProjectContext();

  useDerivedProjectSetupFields();
  useDerivedRECFields();

  return (
    <WorksheetForm isInner isQuote>
      <div>
        <Header as="h2">Project inputs</Header>
        <PricingEstimateFields />
        <hr />

        <WorksheetField
          type="radio"
          fieldLabel="Is the project expected to be ITC eligible?"
          schemaKey="itcDetails.isItcEligible"
          values={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          inline
        />

        {project?.itcDetails?.isItcEligible ? (
          <>
            <div style={{ marginTop: '0px' }}>
              <WorksheetField
                type="radio"
                fieldLabel="Have you safe harbored this project for ITC eligibility?"
                schemaKey="itcDetails.safeHarboredForItc"
                values={[
                  { label: 'Yes', value: true },
                  { label: 'No', value: false },
                ]}
                inline
              />
            </div>
            <WorksheetField
              type="radio"
              fieldLabel="Have you safe harbored this project for FEOC compliance?"
              schemaKey="itcDetails.safeHarboredForFeoc"
              values={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
              inline
            />
            <div style={{ marginTop: '20px' }}>
              <ItcAddersForm />
            </div>
          </>

        ) : null}

        <div style={{ marginTop: '20px', paddingBottom: '20px' }}>
          <WorksheetField
            type="number"
            fieldLabel="Other upfront incentives"
            helpText='Please note that ITC value should not be added as an upfront incentive as it is accounted for elsewhere.'
            schemaKey="upfrontIncentives"
            numberType={InputType.DOLLARS}
            unitField="upfrontIncentiveUnit"
            units={[
              { value: Unit.WDC, label: 'per Wdc', decimals: UnitDecimals.WDC },
              { value: Unit.TOTAL, label: 'total', decimals: UnitDecimals.TOTAL },
            ]}
          />
        </div>

        <hr className="no-margin" />
        <div style={{ marginTop: '10px', paddingBottom: '20px' }}>
          <PricingEstimatePropertyTax />
        </div>
        <hr style={{ marginBottom: '0 !important' }} />
        <h5>Additional revenues and expenses</h5>
        <PricingEstimateRevenueStream />
        <PricingEstimateOperatingExpenses />
        {project?.addressState === 'New Jersey' && (
          <WorksheetField
            type="radio"
            fieldLabel="Renewable energy certificates ownership"
            schemaKey="recOwnership"
            values={RecOwnershipRadioOptions}
          />
        )}
        <StateSpecificRECForm />
      </div>
    </WorksheetForm>
  );
}